import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Image
} from "@react-pdf/renderer";
import { useContext } from "react";
import { DataContext } from "../Context";
// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    color: "black",
    padding: 10,
  },
  section: {
    height: "80px",
    // marginTop: "20px",
    // marginBottom: "20px",
    marginLeft: "10px",
    marginRight: "10px",
    padding: 10,
    borderBottomColor: "#575757c5",
    borderBottom: ".4px",
    // backgroundColor: "red",
    display: "flex",
    flexDirection: "row",
    alignItems: "center"

  },
  viewer: {
    width: "100%", //the pdf viewer will take up all of the width and height
    height: window.innerHeight,
  },
  titleProduct: {
    fontSize: "13px",
    fontWeight: 400,
    marginTop: "8px",
    flex: 1,
  },
  imageProduct: {
    width: "100%",
    maxWidth: "80px"
  },
  imageContainer: {
    width: "100px",
    height: "70px",
    // backgroundColor: "blue",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "4px"
  },
  flexLeftProduct: {
    width: "60%",
    // backgroundColor: "red",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  headerContainer: {
    height: "120px",
    // backgroundColor: "#d2cfcf",
    borderColor: "#575757c5",
    border: ".4px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    // alignItems: "flex-start",
    position: "relative",
    marginBottom: "40px",
    padding: 10,
    borderRadius: "2px",
  }
});

// Create Document Component
function BasicDocument({ CartItem, totalPriceProducts, nombreEmpresa, nombreCliente, direccion }) {



  return (

    <Document>
      {/*render a single page*/}
      <Page size="A4" wrap={true} style={styles.page}>
        <View style={styles.headerContainer}>
          <Text>COTIZACIÓN</Text>
          <Text
            style={{
              fontSize: "9px"
            }}>Correo: laconsolamendoza@gmail.com</Text>
          <Text
            style={{
              fontSize: "9px"
            }}>Telegram: @LaConsola</Text>
          <Text
            style={{
              fontSize: "9px"
            }}>WhatsApp: +54 261-256-5651</Text>
          {
            nombreEmpresa === "" ? null :
              <Text
                style={{
                  fontSize: "9px"
                }}>Empresa a Cotizar: {nombreEmpresa}</Text>
          }
          {
            nombreCliente === "" ? null :
              <Text
                style={{
                  fontSize: "9px"
                }}>Nombre Cliente: {nombreCliente}</Text>
          }
          {
            direccion === "" ? null :
              <Text
                style={{
                  fontSize: "9px"
                }}>Número Cliente: {direccion}</Text>
          }
          <Image
            style={{
              width: "140px",
              position: "absolute",
              top: "0",
              right: "0",

            }}
            source={"https://72jjtpdj.directus.app/assets/9772133b-a7b4-4d5f-b74d-6da6957028b8.png"}>
          </Image>
        </View>
        <View
          style={{
            height: "20px",
            display: "flex",
            flexDirection: "row",
            marginLeft: "20px",
            marginRight: "20px",
          }}>
          <Text style={{
            fontSize: "12px",
            width: "60%",
          }}>PRODUCTO</Text>
          <Text style={{
            fontSize: "12px",
            width: "13%",
            textAlign: "center",
          }}>CANT.</Text>
          <Text style={{
            fontSize: "12px",
            width: "13%",
            textAlign: "center",
          }}>$ UNITARIO</Text>
          <Text style={{
            fontSize: "12px",
            width: "13%",
            textAlign: "center",
          }}>$ TOTAL</Text>
        </View>
        {
          CartItem.map(item => {
            const productQty = item.precio * item.qty
            return (
              <View key={item.id}>
                <View style={styles.section}>
                  <View style={styles.flexLeftProduct}>
                    <View style={styles.imageContainer}><Image style={styles.imageProduct} source={"https://72jjtpdj.directus.app/assets/" + item.imagen}></Image></View>
                    <Text style={styles.titleProduct}>{item.nombre}</Text>
                  </View>
                  <Text style={{
                    width: "13%",
                    textAlign: "center",
                    fontSize: "10px"
                  }}>{item.qty}</Text>

                  <Text style={{
                    width: "13%",
                    textAlign: "left",
                    fontSize: "10px"
                  }}>AR$ {Intl.NumberFormat('de-DE').format(item.precio)}</Text>

                  <Text style={{
                    width: "14%",
                    textAlign: "left",
                    fontSize: "10px",
                    paddingLeft: "14px"
                  }}>AR$ {Intl.NumberFormat('de-DE').format(productQty)}</Text>
                </View>
              </View>
            )
          })
        }
        <View style={{

          height: "80px",
          position: "relative",
          marginTop: "10px"
        }}>
          <View style={{
            width: "30%",
            position: "absolute",
            right: "0",
            top: "0",

            padding: 6,

          }}>
            <Text style={{
              fontSize: "15px",
              textAlign: "right",
              marginRight: "20px"
            }}>TOTAL</Text>
            <Text style={{
              fontSize: "11px",
              textAlign: "right",
              marginRight: "20px"
            }}>AR$ {totalPriceProducts}</Text>
          </View>
          <View>
            <Text style={{ fontSize: "10px", fontWeight: 400, marginLeft: "20px" }}>*Precios y stock sujetos a modificaciones</Text>
          </View>
        </View>
      </Page>
    </Document>

  );
}
export default BasicDocument;